/**
 * SlaBanner — Bandeau d'alerte orange quand des négociations approchent du SLA.
 */
import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

export const SlaBanner = ({ riskCount, onSeeUrgent, onClose }) => {
  if (!riskCount) return null;
  return (
    <div
      data-testid="sla-alert-banner"
      className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-orange-200 bg-orange-50 px-4 py-3.5"
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-orange-100">
          <AlertTriangle className="h-4 w-4 text-orange-600" />
        </div>
        <div>
          <p className="text-sm font-semibold text-orange-800">
            {riskCount} négociation{riskCount > 1 ? 's' : ''} approche{riskCount > 1 ? 'nt' : ''} de leur limite SLA.
          </p>
          <p className="text-xs text-orange-700">Traitez-les rapidement pour éviter l'escalade.</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onSeeUrgent}
          data-testid="sla-banner-see-urgent"
          className="rounded-md border border-orange-200 bg-white px-3 py-1.5 text-sm font-semibold text-orange-600 transition-colors hover:bg-orange-50"
        >
          Voir les urgences
        </button>
        <button type="button" onClick={onClose} data-testid="sla-banner-close" className="text-orange-400 transition-colors hover:text-orange-600">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default SlaBanner;
